import './shop-the-look.css';
import Swiper from 'swiper/bundle';
import 'swiper/css';

export default (element, data) => {
  const init = () => {
    new Swiper('.stlSwiper', {
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 1,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      on: {
        init: function () {
          window.createSwatches();
        },
      },
    });
  };

  init();
};
